export const ADD_CATEGORY_OPTION = 'ADD_CATEGORY_OPTION'
export const ADD_SUBCATEGORY_FILTER = 'ADD_SUBCATEGORY_FILTER'
export const APPLY_SERIES_FILTER = 'APPLY_SERIES_FILTER'
export const REMOVE_CATEGORY_FILTER = 'REMOVE_CATEGORY_FILTER'
export const REMOVE_SUBCATEGORY_FILTER = 'REMOVE_SUBCATEGORY_FILTER'
export const REMOVE_SERIES_FILTER = 'REMOVE_SERIES_FILTER'

export const SET_DIFFICULTY_FILTER = 'SET_DIFFICULTY_FILTER'
export const SET_INTENSITY_FILTER = 'SET_INTENSITY_FILTER'
export const CLEAR_DIFFICULTY_FILTER = 'CLEAR_DIFFICULTY_FILTER'
export const CLEAR_INTENSITY_FILTER = 'CLEAR_INTENSITY_FILTER'

export const SET_FILTER_URL = 'SET_FILTER_URL'
export const APPLY_CATEGORY_FILTER = 'APPLY_CATEGORY_FILTER'
export const SET_PRODUCT_ORDER = 'SET_PRODUCT_ORDER'
export const REPLACE_PRODUCT_FILTERS = 'REPLACE_PRODUCT_FILTERS'
export const CLEAR_ALL_SERIES_FILTERS = 'CLEAR_ALL_SERIES_FILTERS'
export const DEFAULT_SERIES_FILTERS = 'DEFAULT_SERIES_FILTERS'

export const applyCategoryFilter = category => ({
  type: APPLY_CATEGORY_FILTER,
  category
})

export function setFilterUrl (url) {
  return {
    type: SET_FILTER_URL,
    url
  }
}

export function replaceProductFilters (filters) {
  return {
    type: REPLACE_PRODUCT_FILTERS,
    filters
  }
}

export const addCategoryOption = filter => ({
  type: ADD_CATEGORY_OPTION,
  filter
})

export const addSubcategoryFilter = (parentCategory, filter) => ({
  type: ADD_SUBCATEGORY_FILTER,
  parentCategory,
  filter
})

export const addSeriesFilter = (parentCategory, filter) => ({
  type: APPLY_SERIES_FILTER,
  parentCategory,
  filter
})

export const removeSeriesFilter = (parentCategory, filter) => ({
  type: REMOVE_SERIES_FILTER,
  parentCategory,
  filter
})

export const removeCategoryFilter = filterSlug => ({
  type: REMOVE_CATEGORY_FILTER,
  filterSlug
})

export const removeSubcategoryFilter = (
  parentCategory,
  filterSlug,
  clearParent
) => ({
  type: REMOVE_SUBCATEGORY_FILTER,
  parentCategory,
  filterSlug,
  clearParent
})

export const setDifficultyFilter = difficulty => ({
  type: SET_DIFFICULTY_FILTER,
  difficulty
})

export const clearDifficultyFilter = () => ({
  type: CLEAR_DIFFICULTY_FILTER
})

export const setIntensityFilter = intensity => ({
  type: SET_INTENSITY_FILTER,
  intensity
})

export const clearIntensityFilter = () => ({
  type: CLEAR_INTENSITY_FILTER
})

export const setProductOrder = order => ({
  type: SET_PRODUCT_ORDER,
  order
})

export const clearAllSeriesFilters = () => ({
  type: CLEAR_ALL_SERIES_FILTERS
})

export function setDefaultFilter(defaultFilter) {
  return {
    type: DEFAULT_SERIES_FILTERS,
    defaultFilter
  }
}
